export default (
  <path
    d="M6.41418 10.9996H20C20.5523 10.9996 21 11.4473 21 11.9996C21 12.5518 20.5523 12.9996 20 12.9996H6.41418L9.65683 16.2422C10.0473 16.6327 10.0473 17.2659 9.65683 17.6564C9.2663 18.0469 8.63314 18.0469 8.24261 17.6564L3.99997 13.4138C3.21892 12.6327 3.21892 11.3664 3.99997 10.5853L8.24261 6.3427C8.63314 5.95217 9.2663 5.95217 9.65683 6.3427C10.0473 6.73322 10.0473 7.36639 9.65683 7.75691L6.41418 10.9996Z"
    fill="currentColor"
  />
);
